// Declare constants
const DATE_FORMAT_REGEX = /^(0?[1-9]|(1|2)[0-9]|3[0-1])-(0?[1-9]|1[0-2])-\d{4}$/;

export const DateFormatUtils = {
    parseDate: (value: string): Date | undefined => {
        if (!DATE_FORMAT_REGEX.test(value)) return undefined;

        // Split string
        const [ dateStr, monthStr, yearStr ] = value.split('-');

        // Return resulting date
        return new Date(Date.UTC(Number(yearStr), Number(monthStr) - 1, Number(dateStr)));
    }
}

export default DateFormatUtils;